<template>
  <sl-page>
    <div class='page-filter'>
      <Row :gutter="12">
        <Col span="6" :lg="6" :md="8" :sm="8" :xs="24" class="margin-bottom">
          <Input v-model="params.name" placeholder="角色名称"></Input>
        </Col>
        <Col span="18" :lg="18" :md="16" :sm="16" :xs="24" class="page-action">
          <div>
            <Button type="primary" icon="ios-search" @click="list()">搜索</Button>
          </div>
          <div>
            <Button v-permission="'system.role.insert'" type="primary" style="margin-right:8px;" icon="md-add"" @click="create()">新增角色</Button>
            <Button v-permission="'system.role.delete'" :disabled="removeDisable" type="error" icon="md-trash" @click="remove()">删除</Button>
          </div>
        </Col>
      </Row>  
    </div>
    <div class="pg-bd">
      <sl-table ref="table" :loading="loading" :page="page" :columns="columns" :data="data" @on-selection-change="handleSelect" @on-update="handleChange"></sl-table>
    </div>
    <role-item ref="item" @on-update="handleUpdate"></role-item>
  </sl-page>
</template>
<script>
import roleItem from './detail'

const columns_ = [
  {
    type: 'selection',
    width: 65,
    align: 'center'
  },
  {
    title: '角色名称',
    key: 'name'
  },
  {
    title: '创建时间',
    key: 'createDatetimeText'
  },
  {
    title: '备注',
    key: 'remark'
  },
]

export default {
  components: { roleItem },
  data() {
    return {
      columns: [
        ...columns_,
        {
          title: '操作',
          key: 'action',
          width: 150,
          align: 'center',
          render: (h, params) => {
            return this.$utils.link([
              <a v-permission="system.role.update" on-click={()=>this.edit(params)}>编辑</a>,
            ],<Divider type="vertical" />)
          }
        }
      ],
      data: [],
      params:{
        name:''
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total:0
      },
      loading: false,
      modalVisible:false,
      selection:[]
    }
  },
  computed: {
    removeDisable(){
      return this.selection.length == 0
    }
  },
  created(){
    this.list()
  },

  methods: {

    list() {
      this.$request.systems()
      
      let params = {search : {...this.params} , pageSize:this.page.pageSize , pageNum : this.page.pageNum }
      this.loading = true
      this.$request.roles(params).then(resp => {
        this.loading = false
        if (!resp.code) {
          this.data = this.$utils.conv(resp.data.list || [] , {'createDatetime':'datetime'})
          this.page.total = resp.data.total || 0
        }
      })
    },

    edit({row}) {
      this.modalVisible = true
      this.$refs['item'].query( row.id )
    },

    create(){
      this.modalVisible = true
      this.$refs['item'].query( 0 )
    },

    remove(){
      let params = {ids:this.selection}
      this.$ui.confirm(this.$request.roleDeleteBatch ,  '确定删除角色？')(params).then( resp => {
        if(!resp.code){
          this.$Message.success('删除成功')
          this.selection = []
          this.list()
        }
      })
    },

    handleUpdate(){
      this.modalVisible = false
      this.list()
    },

    handleChange( pageNum , pageSize ){
      if( this.page.pageNum != pageNum || this.page.pageSize != pageSize){
        this.page.pageNum = pageNum
        this.page.pageSize = pageSize
        this.list()
      }
    },

    handleSelect(selection){
      this.selection = selection.map(i=>i.id)
    },

    $update(){
      this.list()
    }

  }
}

</script>